import { render, staticRenderFns } from "./MessageReceptors.vue?vue&type=template&id=06bb554e&scoped=true&"
import script from "./MessageReceptors.vue?vue&type=script&lang=js&"
export * from "./MessageReceptors.vue?vue&type=script&lang=js&"
import style0 from "./MessageReceptors.vue?vue&type=style&index=0&id=06bb554e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bb554e",
  null
  
)

export default component.exports